export const url = {
  methods: {
    getUrl(link, id) {
      let url;
      const arr = link.split("/");
      arr[1] === "taxonomy" || arr[1] === "node" || arr[1] === "user"
        ? (url = "/" + id)
        : (url = link);
      return url;
    },
  },
};
